module.exports = __webpack_public_path__ + "assets/1ef2e7544c43e09b65c43edc7d7a8ba8.png";